import { ClickoutUrl } from '@/helpers/clickout-helper';
import { useUserAgent } from '@/helpers/composables/useUserAgent';
import { SwiperRule } from '@/helpers/promotion-helper';
import { useExperiment } from '@/libraries/experiment';
import { getExperimentAffiliateTag } from '@/libraries/experiment/experiment-affiliation';
import { computed } from 'vue';

const delayByVariant = {
	variant_1: 3000,
	variant_2: 7000,
	variant_3: 10000,
};

export function useSwiperBrowserExp() {
	const { activeVariantWithControlGroup: swiperBrowserExpVariant } = useExperiment('SWIPER_BROWSER_EXP_2');
	const { deviceType, userBrowser } = useUserAgent();

	const deviceWithBrowser = computed(() => {
		const browserSuffix = userBrowser.value === 'safari' ? 'saf' : '';

		return deviceType.value === 'mobile' ? `mob${browserSuffix}` : `web${browserSuffix}`;
	});

	const swiperBrowserConfig = computed<SwiperRule | null>(() => {
		if (!swiperBrowserExpVariant.value || swiperBrowserExpVariant.value === 'control') return null;

		return {
			packages: [
				{ id: 'atp_0', shortName: 'atp' },
				{ id: 'cru_1', shortName: 'cru' },
			],
			slideDelay: delayByVariant[swiperBrowserExpVariant.value],
			rules: [
				{
					selectors: {
						browsers: [],
						geoLocations: ['BR', 'IT', 'ES', 'MX', 'US', 'AU', 'FR', 'DE', 'GB', 'CA', 'IN'],
					},
					id: 'cru_1',
				},
			],
			default: { id: 'atp_0' },
		};
	});

	function setSwiperBrowserExpTags(url: ClickoutUrl, swiperIndex: number | undefined) {
		if (!swiperBrowserExpVariant.value) return url;

		const baseTag = getExperimentAffiliateTag({
			affiliationShortId: 'swibro2',
			variant: swiperBrowserExpVariant.value,
			country: 'US',
			placement: 'ft',
			providerShortName: null,
		});

		const tagWithDevice = `${baseTag}-${deviceWithBrowser.value}`;

		const tag = swiperIndex !== undefined ? `${tagWithDevice}-p${swiperIndex}` : tagWithDevice;

		return url.set('uct_ctag', tag);
	}

	return {
		swiperBrowserConfig,
		setSwiperBrowserExpTags,
	};
}
